import React from 'react';
import { Trans } from '@lingui/macro';
// eslint-disable-next-line import/no-unresolved
import { GroupBase } from 'react-select/dist/declarations/src/types';
import { components, NoticeProps } from 'react-select';

const NoOptionsMessage = <Option extends { label: string }, IsMulti extends boolean, Group extends GroupBase<Option>>(
  properties: NoticeProps<Option, IsMulti, Group>,
) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <components.NoOptionsMessage {...properties}>
    <Trans>No options</Trans>
  </components.NoOptionsMessage>
);

export default NoOptionsMessage;
